const getters = {
    leads: (state) => state.leads,
    leadId: (state) =>state.leadId,
    contacts: (state) => state.contacts,
    quotations: (state) => state.quotations,
    opportunity: (state) => state.opportunity,
    loading: (state) => state.loading
};

export default getters;